import axios from "./axios.js";
import {isMacSsoNoIos} from 'Utils/device';
import { isSafari } from 'Utils/browser-info';
let service = axios();
// put请求
export default function httpPut({ url, config = {} }) {
  if(isMacSsoNoIos || isSafari) {
    config.params = config.params ? {...config.params, v: new Date().getTime()} : {v: new Date().getTime()}
  }
  return new Promise((resolve, reject) => {
    service.defaults.withCredentials = true;
    service
      .put(url,config.params, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
